import { atom } from 'jotai';
import { Project } from '../../types/project';

/**
 * 存储排序后的项目列表，用于在 outline 和 task view 之间共享
 */
export const sortedProjectsAtom = atom<Project[]>([]);

/**
 * 存储排序后的时间分组列表，用于在 outline 和 task view 之间共享
 */
export const sortedTimeGroupsAtom = atom<string[]>([]);

/**
 * 存储当前可见的项目 ID 列表，用于在 outline 和 task view 之间共享
 */
export const visibleProjectIdsAtom = atom<string[]>([]);

/**
 * 存储当前可见的时间分组列表，用于在 outline 和 task view 之间共享
 */
export const visibleTimeGroupsAtom = atom<string[]>([]);
